module.exports = __webpack_public_path__ + "static/media/cart-secure-check-icon.e6d5e9bd.svg";